import { useContext, useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { VideoPlayerContext } from "./VideoPlayerContext";

export const VideoProgressBar = () => {
    const { progress, setProgress, videoRef, hidden, showControls, adActive } = useContext(VideoPlayerContext);
    const [ isTimelineHovering, setIsTimelineHovering ] = useState(false);
    const [ hoverOffset, setHoverOffset ] = useState(0);
    const containerRef = useRef<any>();
    const durationRef = useRef<any>();

    const { ref: inViewRef, inView } = useInView({
        triggerOnce: true,
        onChange(inView, entry) {
            showControls();
        },
    });

    const onChange = (evt: any) => {
        const val = evt.target.value;

        const desiredTime = videoRef.current.duration * (+val / 100);

        videoRef.current.currentTime = desiredTime;
        setProgress(+val);
    }

    const getTimestamp = (duration: number) => {
        // Hours, minutes and seconds
        var hrs = ~~(duration / 3600);
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    const onMouseDown = (evt: any) => {
        let offset = Math.max(0, evt.nativeEvent.offsetX);
        offset = Math.min(offset, containerRef.current?.offsetWidth);
        setHoverOffset(offset);
        setIsTimelineHovering(true);
    }

    const onMouseEnter = (evt: any) => {
        let offset = Math.max(0, evt.nativeEvent.offsetX);
        offset = Math.min(offset, containerRef.current?.offsetWidth);
        setHoverOffset(offset);
        setIsTimelineHovering(true);
    }

    const onMouseLeave = () => {
        setIsTimelineHovering(false);
    }

    const onMouseMove = (evt: any) => {
        if (isTimelineHovering) {
            let offset = Math.max(0, evt.nativeEvent.offsetX);
            offset = Math.min(offset, containerRef.current?.offsetWidth);
            setHoverOffset(offset);
        }
    }

    const onTouchDown = (e: any) => {
        var rect = e.target.getBoundingClientRect();
        var x = e.targetTouches[0].pageX - rect.left;
        setHoverOffset(x);
        setIsTimelineHovering(true);


    }

    const onTouchMove = (e: any) => {
        if (isTimelineHovering) {
            var rect = e.target.getBoundingClientRect();
            var x = e.targetTouches[0].pageX - rect.left;
            setHoverOffset(x);
        }

        e.stopPropagation();
    }

    // With timeline hovering we position the timestamp over the users cursor/finter
    // Otherwise, we position it at the current position of the video progress
    // Make sure to constrain within bounds of the player so it's not sticking out the side
    const left = isTimelineHovering ? Math.max(20, Math.min(hoverOffset, containerRef.current?.offsetWidth - (durationRef.current?.offsetWidth + durationRef.current?.offsetWidth / 2) - 2))
     : Math.max(20, Math.min(containerRef.current?.offsetWidth - (durationRef.current?.offsetWidth + durationRef.current?.offsetWidth / 2) - 2, (containerRef.current?.offsetWidth  * (progress / 100))));
     
     // Where in the timeline should we take the display timestamp from?
     const timestampLocation = isTimelineHovering ? (videoRef.current?.duration || 0) * hoverOffset / containerRef.current?.offsetWidth
     : (videoRef.current?.duration || 0) * (progress / 100);

    return (
        <div ref={containerRef} onMouseDown={onMouseDown} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseMove={onMouseMove}
        className="w-full bg-base-300 cursor-pointer border-outline border rounded-2xl h-[16px] p-[2px] mb-[8px] relative">

            {!adActive &&
                <>
                    <div style={{
                        left
                    }}
                        className="rounded-md border-outline border-2 p-2 text-sm bg-base-300 absolute translate -translate-x-1/2 -top-[42px] pointer-events-none">
                        {getTimestamp(timestampLocation)}
                    </div>

                    <div ref={durationRef} className="rounded-md border-outline border-2 p-2 text-sm bg-base-300 absolute right-0 -top-[42px] pointer-events-none">{getTimestamp(videoRef.current?.duration || 0)}</div>
                </>
            }

            <input ref={inViewRef} onInput={onChange} onChange={onChange} disabled={adActive} onTouchMove={onTouchMove} onTouchStart={onTouchDown} onTouchEnd={onMouseLeave}  max={100} type="range" value={progress || 0} className="w-full h-full opacity-0  bg-gray-200 rounded-lg appearance-none cursor-pointer absolute inset-0" />

            <div className="h-[10px] rounded-2xl pointer-events-none" style={{
                background: 'linear-gradient(93.75deg,#e5194d,#8c18f1)',
                appearance: 'none',
                width: `${progress}%`
            }} />
        </div>
    )
}